import useTranslation from "next-translate/useTranslation";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import Image from "next/image";

import { redirect } from "@/utils/helpers";
import { Button, Grid, Link, Typography } from "@/components/core";

export function SignUpConfirm() {
  const { t } = useTranslation("signup");

  const theme = useTheme();
  const mobileMediaQuery = theme.breakpoints.down("md");
  const isMobileDevice = useMediaQuery(mobileMediaQuery);

  return (
    <Grid
      sx={{
        margin: "auto",
        width: "320px",
      }}
      direction="column"
    >
      <Grid.Item xs={12} sx={{ paddingY: 5 }}>
        <Grid spacing={1}>
          <Grid.Item xs={1}>
            <Link href="/login" color="inherit">
              <ArrowBackIcon />
            </Link>
          </Grid.Item>
          <Grid.Item xs>
            <Typography fontSize={26} bold textAlign={isMobileDevice ? "center" : "start"}>
              {t("signUp")}
            </Typography>
          </Grid.Item>
        </Grid>
      </Grid.Item>
      <Grid.Item>
        <Grid sx={{ width: "100%", justifyContent: "center", p: 2, mt: 2 }}>
          <Image src="/images/success.png" alt="success" width={70} height={70} />
        </Grid>
        <Grid.Item sx={{ width: "100%", textAlign: "center", p: 1 }}>
          <Typography fontSize={26} sx={{ paddingBottom: 5 }}>
            {t("signUpConfirm.confirm")}
          </Typography>
        </Grid.Item>
        <Grid.Item sx={{ width: "100%" }}>
          <Typography fontSize={16} sx={{ opacity: "70%", paddingBottom: 5, textAlign: "center" }}>
            {t("signUpConfirm.message")}
          </Typography>
        </Grid.Item>
        <Grid.Item sx={{ width: "100%" }}>
          <Button
            sx={{ fontSize: 18, padding: 2, borderRadius: 2, width: "100%" }}
            variant="contained"
            onClick={() => redirect({ target: "/login" })}
          >
            {t("signUpConfirm.button")}
          </Button>
        </Grid.Item>
      </Grid.Item>
    </Grid>
  );
}
